import Head from 'next/head'
import { FeedbackDialog } from '@/molecules/FeedbackDialog'
import { ForgotPasswordTemplate } from '@/templates/ForgotPasswordTemplate'

const ForgotPasswordPage = () => {
  return (
    <>
      <Head>
        <title>Esqueci minha senha</title>
      </Head>

      <ForgotPasswordTemplate />

      <FeedbackDialog />
    </>
  )
}

export default ForgotPasswordPage
